import { render } from "./App.vue?vue&type=template&id=958834a2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=958834a2&lang=css"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__